import navigation from './components/navigation'
import responsiveToggle from './components/responsive-toggle'
import skipLinks from './components/skip-links';
import tables from './components/tables';
import accordions from './components/accordions';
import dialogs from './components/dialogs';
import tabs from './components/tablist';
import langSwitcher from "./components/lang-switcher";
import faqs from "./components/faqs";
import webinarButtons from "./components/webinar-button";
import headings from "./components/headings";

headings( document.querySelectorAll( '#main-content h2' ) );

webinarButtons( document.querySelectorAll( '.webinar-button' ) );

faqs( document.querySelectorAll( '.faq .faq-container' ) );

tabs( document.querySelectorAll( '.tabs' ) );

langSwitcher();

responsiveToggle( document.querySelector( '.responsive-toggle' ) )

skipLinks( document.getElementById( 'skip-to-content' ) );

navigation( document.querySelector( '.header__nav' ) );
navigation( document.querySelector( '.footer__nav' ) );

tables( document.querySelectorAll( 'table' ) );

accordions( document.querySelectorAll( 'details' ) );

dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );

